import React from "react";
import clsx from "clsx";
import Container from "../views/Container";
import Item from "./Item";

import styles from "./Contact.styles";

const Contact = ({ elements }) => {
	const css = styles();

	const headline = elements.textcontent.items.find(element => element.name === "valHeadline")?.text
	const leftTitle = elements.textcontent.items.find(element => element.name === "valLeftTitle")?.text
	const leftText = elements.textcontent.items.find(element => element.name === "valLeftText")?.text
	const rightTitle = elements.textcontent.items.find(element => element.name === "valRightTitle")?.text
	const rightText = elements.textcontent.items.find(element => element.name === "valRightText")?.text

	return (
		<div className={clsx(css.contact, "mco-extension-component-contact")}>
			<Container
				className={clsx(css.container, "mco-extension-component-contact__container")}
			>
				{headline &&
					<h2 className={clsx(css.headline, "mco-extension-component-contact__headline")}>{headline}</h2>
				}
				<Item title={leftTitle} text={leftText} />
				<Item title={rightTitle} text={rightText} />
			</Container>
		</div>
	);
};

export default Contact;
